import { createFileRoute } from "@tanstack/react-router"
import { ProfileRankPointsPage } from "@/pages/profile/rank-points"

export const Route = createFileRoute("/_authenticated/profile/rank-points")({
	component: ProfileRankPointsPage,
})
